import React, { useMemo } from 'react';

import { EOrderAsLastTimeState } from '@model';

import { IOaLTProcessProps, TOaLTProcessOutput } from '../../model';

import { PafrumsHiddenForm } from './PafrumsHiddenForm';

export const useParfumsProcessForOaLT = ({ setState, lastOrder }: IOaLTProcessProps): TOaLTProcessOutput => {
  return useMemo(() => {
    return {
      actionComponent: <PafrumsHiddenForm lastOrder={lastOrder} />,
      onContinueToCheckout: () => {
        setState(EOrderAsLastTimeState.ACTION_PAGE);
      },
    };
  }, [lastOrder, setState]);
};
